module.exports = __webpack_public_path__ + "static/bg.568c9124.png";